export default __webpack_public_path__ + "static/media/llave-inglesa.900258c1.png";